import { Images } from 'assets/images';
import { useSelector } from 'react-redux';
import { ROUTES } from 'utils/routeNames';
import {
  NavItem,
  StyledImageContainer,
  StyledUserName,
  StyledUserNameContainer,
} from './styled';

export const UserName = () => {
  const { user } = useSelector(({ auth }) => auth);

  return (
    <NavItem to={ROUTES.HOME}>
      <StyledUserNameContainer>
        <StyledImageContainer
          src={
            user?.data?.profile_photo_path === ''
              ? Images.userIcon
              : user?.data?.profile_photo_path
          }
        />
        <StyledUserName>{user?.data?.name}</StyledUserName>
      </StyledUserNameContainer>
    </NavItem>
  );
};
